export default __webpack_public_path__ + "static/media/NSECHStrokePathwayStroke.b0bcd21b.jpg";